import { IBudgetFormData, IBudgetService, IBudgetItem, BudgetRecipientEnum } from '../types';

export const createEmptyService = (): IBudgetService => ({
  ref: '',
  serviceId: '',
  serviceType: '',
  items: [],
  subtotal: 0,
});

export const createEmptyExternalService = (): IBudgetService => ({
  ref: '',
  serviceId: '',
  serviceType: '',
  items: [],
  subtotal: 0,
  isExternalService: true,
});

export const createEmptyItem = (ref: string): IBudgetItem => ({
  ref,
  item: '',
  description: '',
  quantity: '01',
  value: 0,
  discount: '00%',
  subtotal: 0,
});

export const createEmptyBudgetFormData = (
  occurrenceId: string,
  budgetId: string,
  userProfile?: {
    sub?: string;
    azp?: string;
    account?: string;
    givenName?: string;
    familyName?: string;
    name?: string;
    locale?: string;
    email?: string;
  },
): IBudgetFormData => ({
  occurrenceId,
  budgetId,
  number: '',
  userProfile: userProfile
    ? {
        sub: userProfile.sub,
        azp: userProfile.azp,
        account: userProfile.account,
        givenName: userProfile.givenName,
        familyName: userProfile.familyName,
        name: userProfile.name,
        locale: userProfile.locale,
        email: userProfile.email,
      }
    : undefined,
  vehicleData: {},
  clientData: {},
  recipient: BudgetRecipientEnum.TOWER,
  services: [
    {
      ref: '',
      serviceId: '',
      serviceType: '',
      items: [],
      subtotal: 0,
    },
  ],
  files: [],
  summary: {
    subtotal: 0,
    discounts: 0,
    totalToPay: 0,
  },
  counterProposal: false,
});

